export const getFileTitle = (title: string, ext: string): string => {
    const arr = title.split('_');
    return arr.slice(0, arr.length).join('_') + ext;
};
